/** AspectRatioContainer registration: the parser. Render side: `./index.r3f`. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseAspectRatioContainer } from './parser';
const aspectRatioContainerRegistration = {
    typeName: 'AspectRatioContainer',
    parser: parseAspectRatioContainer,
};
nodeRegistry.register(aspectRatioContainerRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map